<script>
import { store } from './store.js'

export default {
  props: ['item'],
  data() {
    return {
      store
    }
  },
  mounted() {
      this.changeFont();
  },
  updated() {
    
  },

   computed: {
    // a computed getter
    mediaId() {
      var output = this.item.id + '-media-button'; 
      return  output;
    },

    mediaDiv() {
      var output = this.item.id + '-media-button'; 
      return  output;
    },

  },

  methods: {
    changeFont: function(event){
        var dynamlink = 'https://fonts.googleapis.com/css?family=';
        dynamlink += this.item.fontfamily + ':100,200,300,400,500,600,700,800,900,100italic,200italic,300italic,400italic,500italic,600italic,700italic,800italic,900italic';
        var stylesheet = jQuery("<link>", {
          rel: "stylesheet",
          type: "text/css",
          href: dynamlink,
          id: "font-" + this.item.fontfamily,
        });
        stylesheet.appendTo("head");
    },
  },

  
};
</script>

<template>


        <div class="og-inside"> 
						<div class="tabs">
							<ul>
								<li><a href="#tab-01">Data</a></li>
								<li><a href="#tab-02">Design</a></li>
								<li><a href="#tab-03">Position</a></li>
							</ul>
							<div id="tab-01">
								<div class="form-wrap">
									<div class="og-form-fields-row">
										<div class="og-form-field">
											<label for="text">Caption</label>
											<input v-model="item.caption" type="text" placeholder="Text caption">
										</div>
									</div><!-- .og-form-fields-row -->
									
									<h3 class="">Font</h3>
									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
											<label for="font-family">Font family</label>
											<select v-model="item.fontfamily" @change="changeFont">
                        <option v-for="(value, name) in store.googlefonts" :value="name" :key="name">{{ value }}</option>
                      </select>
										</div>							
										<div class="og-form-field og-form-field-fourth">
											<label for="font-size">Size <span class="og-label-info">(px)</span></label>
											<input v-model="item.fontsize" placeholder="font-size" type="number">
										</div>
										<div class="og-form-field og-form-field-fourth">
											<label>Line-h</label>
											<input v-model="item.lineheight" placeholder="lineheight" min="0" step="0.1" type="number">
										</div>

									</div><!-- .og-form-fields-row -->
									<div class="og-form-fields-row">
										
										<div class="og-form-field og-form-field-third">
											<label for="font-weight">Weight</label>
											<select v-model="item.fontweight">
												<option value="100">Thin (100)</option>
												<option value="200">Extra Light (200)</option>
												<option value="300">Light (300)</option>
												<option value="400">Normal (400)</option>
												<option value="500">Medium (500)</option>
												<option value="600">Semi Bold (600)</option>
												<option value="700">Bold (700)</option>
												<option value="800">Extra Bold (800)</option>
												<option value="900">Black (900)</option>
											</select>
										</div>
										<div class="og-form-field og-form-field-third">
											<label for="font-weight">Transform</label>
											<select v-model="item.texttransform">
												<option value="none">Initial</option>
												<option value="uppercase">UPPERCASE</option>
												<option value="lowercase">lowercase</option>
												<option value="capitalize">Capitalize</option>
											</select>
										</div>
										<div class="og-form-field og-form-field-third">
											<label for="font-weight">Style</label>
											<select v-model="item.fontstyle">
												<option value="normal">Normal</option>
												<option value="italic">Italic</option>
											</select>
										</div>
										
									</div><!-- .og-form-fields-row -->

									<h3 class="">Decoration</h3>

										<div class="og-form-fields-row">
											<div class="og-form-field og-form-field">
												<label>
													<input type="checkbox" value="underline" v-model="item.decorationline"> Underline
												</label>
												<label>
													<input type="checkbox" value="line-through" v-model="item.decorationline"> Line-through
												</label>
											</div>
										</div>

									<h3 class="">Alignment</h3>

									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
											<label for="">Horizontal</label>
											<select v-model="item.horizontalalign">
												<option value="left">Left</option>
												<option value="center">Center</option>
												<option value="right">Right</option>
											</select>
										</div>
										<div class="og-form-field og-form-field-half">
											<label for="">Vertical</label>
											<select v-model="item.verticalalign">
												<option value="start">Top</option>
												<option value="center">Center</option>
												<option value="end">Bottom</option>
											</select>
										</div>
									</div><!-- .og-form-fields-row -->

									<!-- <h3 class="">Radio & Checkbox</h3>
									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
											<label>
												<input value="1" type="checkbox" name="checkbox-1" id="checkbox-1" checked> Checkbox-1
											</label>
											<label>
												<input value="2" type="checkbox" name="checkbox-2" id="checkbox-2"> Checkbox-2
											</label>
											<label>
												<input value="3" type="checkbox" name="checkbox-3" id="checkbox-3"> Checkbox-3
											</label>
										</div>
										<div class="og-form-field og-form-field-half">
											<fieldset>
												<label>
													<input value="1" type="radio" name="radio" id="radio-1"> Radio-1
												</label>
												<label>
													<input value="2" type="radio" name="radio" id="radio-2" checked> Radio-2
												</label>
												<label>
													<input value="3" type="radio" name="radio" id="radio-3"> Radio-3
												</label>
											</fieldset>
										</div>
									</div> --> <!-- .og-form-fields-row -->
								</div><!-- .form-wrap -->					
							</div>
							<div id="tab-02">
							<div class="form-wrap">
									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
											<label for="color">Color</label>
											<input v-model="item.color" placeholder="color" type="color">
										</div>
										<div class="og-form-field og-form-field-half">
												<label>Opacity</label>
												<input v-model="item.opacity" min="0" max="100" type="number">
										</div>
									</div><!-- .og-form-fields-row -->

									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
											<label for="color">Bg Color</label>
											<input v-model="item.bgcolor" placeholder="color" type="color">
										</div>
										<div class="og-form-field og-form-field-half">
												<label>Bg Opacity</label>
												<input v-model="item.bgopacity" min="0" max="100" type="number">
										</div>
									</div><!-- .og-form-fields-row -->

									<h3 class="">Border</h3>

									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
												<label>Width</label>
												<input v-model="item.borderwidth" placeholder="width" min="0" type="number">
											</div>
											<div class="og-form-field og-form-field-half">
												<label>Style</label>
												<select v-model="item.borderstyle">
													<option value="solid">Solid</option>
													<option value="double">Double</option>
													<option value="dotted">Dotted</option>
													<option value="dashed">Dashed</option>
												</select>			
											</div>
									</div>

									<div class="og-form-fields-row">
											<div class="og-form-field og-form-field-half">
												<label>Color</label>
												<input v-model="item.bordercolor" placeholder="color" type="color">
											</div>
											<div class="og-form-field og-form-field-half">
												<label>Radius</label>
												<input v-model="item.borderradius" placeholder="width" min="0" type="number">
											</div>
									</div>

									<h3 class="">Shadow</h3>
										<div class="og-form-fields-row">
											<div class="og-form-field og-form-field-half">
												<label>Horizontal</label>
												<input v-model="item.hshadow" type="number">
											</div>
											<div class="og-form-field og-form-field-half">
												<label>Vertical</label>
												<input v-model="item.vshadow" type="number">
											</div>
										</div>
										<div class="og-form-fields-row">
											<div class="og-form-field og-form-field-third">
												<label>Radius</label>
												<input v-model="item.radiusshadow" min="0" type="number">
											</div>
											<div class="og-form-field og-form-field-third">
												<label>Color</label>
												<input v-model="item.colorshadow" placeholder="color" type="color">
											</div>
											<div class="og-form-field og-form-field-third">
												<label>Opacity</label>
												<input v-model="item.opacityshadow" min="0" max="100" type="number">
											</div>
										</div>

									<h3 class="">Padding</h3>

									<div class="og-form-fields-row">
											<div class="og-form-field og-form-field-half">
												<label>Horizontal (px)</label>
												<input v-model="item.horizontalpadding" placeholder="width" min="0" type="number">
											</div>
											<div class="og-form-field og-form-field-half">
												<label>Vertical (px)</label>
												<input v-model="item.verticalpadding" placeholder="width" min="0" type="number">
											</div>
									</div>

								</div><!-- .form-wrap -->
							</div>
							<div id="tab-03">
								<div class="form-wrap">
									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-half">
											<label for="width">Width</label>
											<input v-model="this.item.frame.width" type="number">
										</div>
										<div class="og-form-field og-form-field-half">
											<label for="height">Height</label>
											<input v-model="this.item.frame.height" type="number">
										</div>
									</div>
									<div class="og-form-fields-row">
										<div class="og-form-field og-form-field-third">
											<label for="width">Top</label>
											<input v-model="this.item.frame.translatey" type="number">
										</div>
										<div class="og-form-field og-form-field-third">
											<label for="height">Left</label>
											<input v-model="this.item.frame.translatex" type="number">
										</div>
										<div class="og-form-field og-form-field-third">
											<label for="rotation">Rotation</label>
											<input v-model="this.item.frame.rotate" type="number">
										</div>
									</div>
								</div><!-- .form-wrap -->
							</div>
						</div><!-- .tabs -->
					</div><!-- .inside -->				
					
</template>
